import React, { Component } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import Collect from '@fiverr-private/collect';
import GigWrapper from '../Components/GigWrapper/GigWrapper';
import SellerInfo from '../Components/SellerInfo';
import SlideImage from '../Components/Media/SlideImage';
import Title from '../Components/Title';
import Price from '../Components/Price';
import Rating from '../Components/Rating';
import Badge from '../Components/Badge';
import ContextualLink from '../Components/ContextualLink';
import withTransformProps from '../hoc/withTransformProps';
import { listviewCardTransformer } from '../utils/transformers/listview';
import { createClickedElement, trackGigForClickType, enrichGigTracker } from '../utils';
import LoadingGigCard from '../loading/LoadingGigCard';
import { ListViewCardType } from '../types';
import {
    BUY_IT_AGAIN_BADGE,
    ELEMENTS_NAME,
    ELEMENTS_TYPE,
    SUBSCRIPTION_BADGE,
    TALENT_BADGE,
    URL_TARGET,
} from '../Components/constants';
import './index.scss';
import { LIST_VIEW_CARD } from '../../GigCardListings/utils/constants';

class ListViewCard extends Component {
    getChildContext() {
        const { tracker } = this.props;

        return { ...enrichGigTracker(tracker, this.props) };
    }

    render() {
        const {
            uId,
            id,
            url,
            title,
            localizedTitle,
            translatedTitle,
            showTranslatedUGC,
            price,
            priceLabelType,
            isPro,
            seller,
            ratings,
            badge = {},
            asset,
            isLoading,
            lazyLoad,
            isPromotedGig,
            urlTarget = URL_TARGET.self,
            collectProps,
            ExternalWrapper,
            showFooter = true,
            showNewImageRatio,
            hidePrefix = true,
            shouldDisplayFees,
        } = this.props;

        const isTalent = badge.type === TALENT_BADGE;
        const isBuyItAgain = badge.type === BUY_IT_AGAIN_BADGE;
        const isSubscription = badge.type === SUBSCRIPTION_BADGE;
        const showBadge = isTalent || isBuyItAgain || isSubscription;
        const showProBadge = isPro;
        const containerClassesNames = classNames('list-view-card', {
            'has-badge': showBadge,
        });

        const { trackEvent } = this.getChildContext();

        return (
            <GigWrapper
                type={LIST_VIEW_CARD}
                uId={uId}
                isPro={isPro}
                isLoading={isLoading}
                classes={['list-view-card']}
                LoadingComponent={LoadingGigCard}
                ExternalWrapper={ExternalWrapper}
                gig={this.props}
            >
                <div className={containerClassesNames}>
                    <header>
                        <div className={classNames('side-image', { 'box-image-ratio': showNewImageRatio })}>
                            <div className="card-badge-wrap">
                                {showProBadge && <Badge type={badge.type} excludeTooltip={true} classes="" />}
                            </div>
                            <ContextualLink
                                href={url}
                                target={urlTarget}
                                onMouseDown={(e) => trackGigForClickType(e.button, trackEvent, clickedElement)}
                            >
                                <SlideImage asset={asset} lazy={lazyLoad} showNewImageRatio={showNewImageRatio} />
                            </ContextualLink>
                            <div className="collect-container">
                                <Collect
                                    {...collectProps}
                                    resource={{ id: id.toString(), type: Collect.RESOURCE_TYPES.GIG }}
                                    showMenu={false}
                                    className="card-collect"
                                />
                            </div>
                        </div>
                        <aside className="header-right">
                            <div className="title-fav-container">
                                <Title
                                    hidePrefix={hidePrefix}
                                    title={title}
                                    showTranslatedUGC={showTranslatedUGC}
                                    localizedTitle={localizedTitle}
                                    translatedTitle={translatedTitle}
                                    url={url}
                                    urlTarget={urlTarget}
                                />
                            </div>
                            <div className="rating-badge-container">
                                <Rating {...ratings} />
                                {showBadge && <Badge type={badge.type} excludeTooltip={true} classes="" />}
                            </div>
                        </aside>
                    </header>
                    {showFooter && (
                        <footer>
                            <SellerInfo {...seller} isPromoted={isPromotedGig} withBadge={false} />
                            <Price
                                shouldDisplayFees={shouldDisplayFees}
                                url={url}
                                price={price}
                                priceLabelType={priceLabelType}
                            />
                        </footer>
                    )}
                </div>
            </GigWrapper>
        );
    }
}

ListViewCard.propTypes = ListViewCardType;

ListViewCard.childContextTypes = {
    trackEvent: PropTypes.func,
    trackImpression: PropTypes.func,
};

ListViewCard.defaultProps = {
    showTranslatedUGC: false,
};

export const clickedElement = createClickedElement(ELEMENTS_NAME.GIG_IMAGE, ELEMENTS_TYPE.LINK);

export default withTransformProps(listviewCardTransformer)(ListViewCard);
